module.exports = __webpack_public_path__ + "adjust.svg";